import React, { useEffect } from 'react';
import { isDataLoaded } from '../../types';
import { useAlarmChannelDetails } from '../../data/DataProviders/AlarmChannelDetailDataProvider';
import { MaxQmaxGraphProvider } from '../../data/DataProviders/QmaxGraphDataProvider';
import { QmaxGraph } from '../QmaxGraph/QmaxGraph';
import { PDIGraphDataProvider } from '../../data/DataProviders/PDIGraphDataProvider';
import { PDIGraph } from '../PdiGraph/PdiGraph';
import { DatetimeListDataProvider, useDatetimeData } from '../../data/DataProviders/DatetimeListDataProvider';
import { PhaseResolvedGraphOverview } from '../PhaseResolvedGraphOverview/PhaseResolvedGraphOverview';
import { ConfirmationPopUp } from '../ConfirmationPopUp/ConfirmationPopUp';
import {
    Typography,
    Divider,
    ListSubheader,
    Paper,
    Radio,
    FormControl,
    FormControlLabel,
    RadioGroup,
    TextField,
    Box,
} from '@mui/material';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { Icon } from '../../lib/icons';
import chartLabelNameStyle from '../../app/insulgard/ChartLabelNameStyle';
import { ActionRow } from '../OverviewCard/ActionRow';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { AppRoute } from '../../routes';
import { SuggestionAcceptReject } from '../TimelineEventDetailCard/SuggestionAcceptReject';
import { getUserId, useAuthHelper, useAuthState } from '../../components/AuthContextProvider';
import { useDispatch, useSelector } from 'react-redux';
import { Actions, Thunks } from '../../actions';
import { useToasts } from '../../data/DataProviders/ToastProvider';
import { Selectors } from '../../selectors';
import { DataIndicators } from '../DataIndicators';
export const AlarmChannelDetails: React.FC = () => {
    const { t } = useLanguageLocale();
    const currentAppRoute = useCurrentAppRoute();
    const dispatch = useDispatch();
    const getResponseData = useDatetimeData();
    const { addToast, removeToast } = useToasts();
    const authState = useAuthState();
    const userId = getUserId(authState) || '';
    const classes = chartLabelNameStyle();
    const alarmChannelData = useAlarmChannelDetails();

    const deviceId = isDataLoaded(alarmChannelData) ? alarmChannelData.value.deviceId : '';
    const alarmId = isDataLoaded(alarmChannelData) ? alarmChannelData.value.alarmId : '';
    const channelNumber: any = isDataLoaded(alarmChannelData) ? alarmChannelData.value.channelNumber : null;
    const alarmEndDate = isDataLoaded(alarmChannelData) ? alarmChannelData.value.alarmDate : '';
    const channelName = isDataLoaded(alarmChannelData) ? alarmChannelData.value.channelName : '';
    const dataAnalyticsSuggestion = isDataLoaded(alarmChannelData)
        ? alarmChannelData.value.dataAnalyticsSuggestion
        : undefined;

    const canEdit = isDataLoaded(alarmChannelData) ? alarmChannelData.value.canEdit : false;

    const acceptUserId =
        isDataLoaded(alarmChannelData) && alarmChannelData.value.acceptedSuggetion !== undefined
            ? alarmChannelData.value.acceptedSuggetion.userId
            : '';

    const rejectUserId =
        isDataLoaded(alarmChannelData) && alarmChannelData.value.rejectedSuggetion !== undefined
            ? alarmChannelData.value.rejectedSuggetion.userId
            : '';

    const acceptedUserSuggestions =
        isDataLoaded(alarmChannelData) && alarmChannelData.value.acceptedSuggetion !== undefined
            ? alarmChannelData.value.acceptedSuggetion.userComments
            : '';

    const rejectedUserSuggestions =
        isDataLoaded(alarmChannelData) && alarmChannelData.value.rejectedSuggetion !== undefined
            ? alarmChannelData.value.rejectedSuggetion.userSuggestion
            : '';

    const rejectedUserComments =
        isDataLoaded(alarmChannelData) && alarmChannelData.value.rejectedSuggetion !== undefined
            ? alarmChannelData.value.rejectedSuggetion.userComments
            : '';

    const rejectedUserSuggestion =
        isDataLoaded(alarmChannelData) && alarmChannelData.value.rejectedSuggetion !== undefined
            ? alarmChannelData.value.rejectedSuggetion.userSuggestion
            : '';

    const userAccepted = isDataLoaded(alarmChannelData) ? alarmChannelData.value.isSuggestionAccepted : false;
    const userRejected = isDataLoaded(alarmChannelData) ? alarmChannelData.value.isSuggestionRejected : false;

    const authHelper = useAuthHelper();
    const [PDIDialogBox, setPDIDialogBox] = React.useState(false);
    const [openQmaxDialogBox, setopenQmaxDialogBox] = React.useState(false);
    const [infoBoxPhaseGraph, setinfoBoxPhaseGraph] = React.useState(false);
    const [rejectedResaonBox, setRejectedReasonBox] = React.useState(false);
    const [textValue, setTextValue] = React.useState('');
    const [radioValue, setRadioValue] = React.useState('lowPd');
    const [actionTypes, setActionTypes] = React.useState('');
    const [rejected, setRejectedAction] = React.useState(userRejected);
    const [accepted, setAcceptedAction] = React.useState(userAccepted);
    const [resetConfirmation, setResetConfirmation] = React.useState(false);
    const [isCanEdit, setCanEdit] = React.useState(canEdit);
    const [isLoggedUser, setLoggedUser] = React.useState(userId);
    const [isRejectedUserId, setRejectedUserId] = React.useState(rejectUserId);
    const [isAcceptedUserId, setAcceptedUserId] = React.useState(acceptUserId);
    const [isAcceptedSuggestion, setAcceptedSuggestion] = React.useState(acceptedUserSuggestions);

    const alarmSuggestionState = useSelector(Selectors.AlarmUserSuggestionSelector.AlarmSuggestionAcceptReject);

    const dataItem: any = [];
    let datesWithChannelResult: any = [];
    if (isDataLoaded(getResponseData)) {
        datesWithChannelResult = getResponseData.value.datesWithChannel;
        datesWithChannelResult.map((id: any) => dataItem.push(id.dateTime));
    }
    const findAlarmIndex = dataItem.indexOf(alarmEndDate);

    useEffect(() => {
        if (isDataLoaded(alarmChannelData)) {
            setRejectedAction(alarmChannelData.value.isSuggestionRejected);
            setAcceptedAction(alarmChannelData.value.isSuggestionAccepted);
            setCanEdit(alarmChannelData.value.canEdit);
            setRejectedUserId(rejectUserId);
            setAcceptedUserId(acceptUserId);
            setLoggedUser(isLoggedUser);
            setRadioValue(rejectedUserComments);
            setTextValue(rejectedUserSuggestion);
            setAcceptedSuggestion(alarmChannelData.value.acceptedSuggetion?.userComments);
        }
        if (isLoggedUser !== isAcceptedUserId) {
            removeToast();
        } else if (isLoggedUser !== isRejectedUserId) {
            removeToast();
        }
    }, [alarmChannelData]);

    useEffect(() => {
        if (!alarmSuggestionState.loading && alarmSuggestionState.success && isDataLoaded(alarmChannelData)) {
            addToast('User Suggestion Form Updated Successfully');
            if (actionTypes === 'accepted') {
                setAcceptedAction(true);
                setAcceptedUserId(isLoggedUser);
                setCanEdit(true);
                setRejectedAction(false);
            } else if (actionTypes === 'rejected') {
                setRejectedAction(true);
                setRejectedUserId(isLoggedUser);
                setAcceptedAction(false);
                setCanEdit(true);
            } else if (actionTypes === 'edit') {
                setRadioValue(radioValue);
                setTextValue(textValue);
                setRejectedAction(true);
                setRejectedUserId(isLoggedUser);
                setAcceptedAction(false);
                setCanEdit(true);
            }
            dispatch(Actions.AlarmSuggestion.AlarmSuggestionAcceptRejectUnmounted());

            setInterval(() => {
                removeToast();
            }, 6000);
        }
    }, [alarmSuggestionState.loading, alarmSuggestionState.success]);

    const resetConfirmState = useSelector(Selectors.ResetUserSuggestion.resetUserSuggestion);
    useEffect(() => {
        if (!resetConfirmState.deleteUserLoading && resetConfirmState.deleteUserSuccess) {
            addToast(t('INSULGARD.RESET_ACPT_RJCT'));
            setAcceptedAction(false);
            setCanEdit(true);
            setRejectedAction(false);
            dispatch(Actions.ResetSuggestion.resetUserSuggestionUnmounted());
        }

        setInterval(() => {
            removeToast();
        }, 6000);
    }, [resetConfirmState.deleteUserLoading, resetConfirmState.deleteUserSuccess]); //eslint-disable-line react-hooks/exhaustive-deps

    let alarmStartDate: any, newAlarmEndDate: any;
    if (isDataLoaded(alarmChannelData)) {
        const d = new Date(alarmEndDate);
        d.setMonth(d.getMonth() - 3);
        const dateArr = d.toLocaleDateString().split('/');
        let days = dateArr[1];
        let months = dateArr[0];
        if (dateArr[0].length < 2) months = `0${dateArr[0]}`;
        if (dateArr[1].length < 2) days = `0${dateArr[1]}`;
        alarmStartDate = `${dateArr[2]}${'-'}${months}${'-'}${days}`;

        const alarmDate = new Date(alarmEndDate);
        alarmDate.setMonth(alarmDate.getMonth());
        const alarmDateArr = alarmDate.toLocaleDateString().split('/');
        let day = alarmDateArr[1];
        let month = alarmDateArr[0];
        if (alarmDateArr[0].length < 2) month = `0${alarmDateArr[0]}`;
        if (alarmDateArr[1].length < 2) day = `0${alarmDateArr[1]}`;
        newAlarmEndDate = `${alarmDateArr[2]}${'-'}${month}${'-'}${day}`;
    }

    const openPDIDialogBox = (value: any): void => {
        setPDIDialogBox(value);
    };
    const closePDIQmaxDialogBox = (): void => {
        setPDIDialogBox(false);
    };

    const openQmaxDialogBoxContent = (value: any): void => {
        setopenQmaxDialogBox(value);
    };
    const closeQmaxDialogBox = (): void => {
        setopenQmaxDialogBox(false);
    };

    const sendPRData = (): void => {
        setinfoBoxPhaseGraph(false);
    };
    const prDialogPopup = (): void => {
        setinfoBoxPhaseGraph(true);
    };

    const userAcceptConfirm = (actionType: boolean): void => {
        if (actionType) {
            setActionTypes('accepted');

            dispatch(
                Thunks.AlarmSuggestion.userAcceptThunk(alarmId, deviceId, authHelper, addToast, dataAnalyticsSuggestion)
            );
        }
    };

    const userEditForm = (value: boolean, actionType: boolean): void => {
        if (actionType) {
            setRejectedReasonBox(value);
            setActionTypes('edit');
            setRadioValue(radioValue);
            setTextValue(textValue);
        }
    };

    const userRejectConfirm = (value: any, actionType: boolean): void => {
        setRadioValue('');
        setTextValue('');
        if (actionType === true) {
            setRejectedReasonBox(value);
            setActionTypes('rejected');
        }
    };

    const closeRejectForm = (): void => {
        setRejectedReasonBox(false);
    };
    const sendUserRejectedReason = (): void => {
        setRejectedReasonBox(true);

        if (radioValue !== '') {
            dispatch(
                Thunks.AlarmSuggestion.userSuggestionAcceptReject(
                    alarmId,
                    deviceId,
                    radioValue,
                    textValue,
                    authHelper,
                    addToast
                )
            );

            setRejectedReasonBox(false);
        }
    };

    const onChangeNotes = (event: any): void => {
        setTextValue(event.target.value);
    };

    const radioButtonHandleChanged = (event: any): void => {
        setRadioValue(event.target.value);
    };

    const resetSendConfirmation = (): void => {
        dispatch(Thunks.ResetSuggestionThunks.ResetUserSuggestionForm(alarmId, deviceId, authHelper, addToast));
        setResetConfirmation(false);
    };

    const openResetConfirmation = (value: any): void => {
        setResetConfirmation(value);
    };

    const closePopUp = (): void => {
        setResetConfirmation(false);
    };

    const redirectToSpecficTab = (tavValue: string, alarmDateIndex?: number, chNumber?: any): AppRoute => {
        let dynamicAppRoute: AppRoute = { type: 'InvalidRoute' };

        if (currentAppRoute.type === 'OverviewSiteEventDetails') {
            dynamicAppRoute = {
                type: 'TimelineSiteTabDetails',
                eventId: currentAppRoute.alarmId,
                deviceId: currentAppRoute.deviceId,
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
                tabId: tavValue,
                phaseDate:
                    alarmDateIndex && alarmDateIndex !== undefined
                        ? alarmDateIndex
                        : 0 || (chNumber && chNumber !== undefined)
                        ? chNumber
                        : 0,
            };
        }

        if (currentAppRoute.type === 'OverviewSiteTimelineEventDetails') {
            dynamicAppRoute = {
                type: 'TimelineSiteTabDetails',
                eventId: currentAppRoute.alarmId,
                deviceId: currentAppRoute.deviceId,
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
                tabId: tavValue,
                phaseDate:
                    alarmDateIndex && alarmDateIndex !== undefined
                        ? alarmDateIndex
                        : 0 || (chNumber && chNumber !== undefined)
                        ? chNumber
                        : 0,
            };
        }

        if (currentAppRoute.type === 'TimelineLocationEventDetails') {
            dynamicAppRoute = {
                type: 'TimelineLocationTabDetails',
                eventId: currentAppRoute.alarmId,
                deviceId: currentAppRoute.deviceId,
                locationId: currentAppRoute.locationId,
                tabId: tavValue,
                phaseDate:
                    alarmDateIndex && alarmDateIndex !== undefined
                        ? alarmDateIndex
                        : 0 || (chNumber && chNumber !== undefined)
                        ? chNumber
                        : 0,
            };
        }

        if (currentAppRoute.type === 'TimelineOrganizationEventDetails') {
            dynamicAppRoute = {
                type: 'TimelineOrganizationTabDetails',
                eventId: currentAppRoute.alarmId,
                deviceId: currentAppRoute.deviceId,
                tabId: tavValue,
                phaseDate:
                    alarmDateIndex && alarmDateIndex !== undefined
                        ? alarmDateIndex
                        : 0 || (chNumber && chNumber !== undefined)
                        ? chNumber
                        : 0,
            };
        }
        return dynamicAppRoute;
    };

    return (
        <div data-testid="alarm-Channel-Detail">
            <Paper>
                {!isDataLoaded(alarmChannelData) && (
                    <DataIndicators
                        errorMessage="Record not found"
                        emptyMessage="Record not found"
                        inline
                        data={alarmChannelData}
                        emptyIcon="Devices"
                        isEmpty={false}
                        isDetailedInfo={false}
                    />
                )}

                {resetConfirmation && (
                    <ConfirmationPopUp
                        data-testid="resetForm"
                        title={t('EVENT_DETAILS.RESET_INFORMATION_TITLE')}
                        body={<Typography>{t('EVENT_DETAILS.RESET_INFORMATION_ALERT')}</Typography>}
                        show={resetConfirmation}
                        handleOk={resetSendConfirmation}
                        width="xs"
                        okButtonShow={true}
                        cancelButtonsShow={true}
                        okButtonText={t('ACTIONS.RESET')}
                        cancelButtonText={t('ACTIONS.CANCEL')}
                        closeDialog={closePopUp}
                    ></ConfirmationPopUp>
                )}

                {rejectedResaonBox && (
                    <ConfirmationPopUp
                        title={
                            actionTypes === 'rejected'
                                ? t('EVENT_DETAILS.ALARMCHANNEL_REJECT_TITLE')
                                : '' || actionTypes === 'edit'
                                ? `This activity was classified as "${radioValue}". Do you want to edit the classification?`
                                : ''
                        }
                        body={
                            <Typography component={'div'} style={{ marginBottom: 30, fontSize: '14px' }}>
                                <div style={{ width: '85%', fontSize: '14px', lineHeight: '20px' }}>
                                    {t('EVENT_DETAILS.ALARMCHANNEL_REJECT_BODY_CONTENT')}
                                </div>
                                <FormControl fullWidth>
                                    <RadioGroup
                                        data-testid="radioButtonControl"
                                        value={radioValue}
                                        onChange={radioButtonHandleChanged}
                                        row
                                    >
                                        <FormControlLabel
                                            style={{ padding: '0px 10px' }}
                                            value="noPd"
                                            control={<Radio />}
                                            label="No PD"
                                            data-testid="noPD"
                                        />
                                        <FormControlLabel
                                            style={{ padding: '0px 10px' }}
                                            value="lowPd"
                                            control={<Radio />}
                                            label="Low PD"
                                        />
                                        <FormControlLabel
                                            style={{ padding: '0px 10px' }}
                                            value="minorPd"
                                            control={<Radio />}
                                            label="Minor PD"
                                        />
                                        <FormControlLabel
                                            style={{ padding: '0px 10px' }}
                                            value="realPd"
                                            control={<Radio />}
                                            label="Real PD"
                                        />
                                        <FormControlLabel
                                            style={{ padding: '0px 0px' }}
                                            value="noisePd"
                                            control={<Radio />}
                                            label="Noise PD"
                                        />
                                        <FormControlLabel
                                            style={{ padding: '0px 10px' }}
                                            value="otherPd"
                                            control={<Radio />}
                                            label="Other"
                                        />
                                    </RadioGroup>
                                </FormControl>

                                <Box>
                                    <TextField
                                        inputProps={{ 'data-testid': 'notes', maxLength: 500 }}
                                        variant="filled"
                                        id="Additional Comments"
                                        multiline
                                        maxRows={Infinity}
                                        data-testid="textarea"
                                        label="Additional Comments"
                                        value={textValue}
                                        fullWidth
                                        onChange={(event): void => {
                                            onChangeNotes(event);
                                        }}
                                    />
                                </Box>
                            </Typography>
                        }
                        okButtonText={'SUBMIT'}
                        cancelButtonText={'CANCEL'}
                        show={rejectedResaonBox}
                        handleOk={sendUserRejectedReason}
                        width="xs"
                        //loading={AlarmSuggestionAcceptRejectStarted}
                        okButtonShow={true}
                        cancelButtonsShow={true}
                        closeDialog={closeRejectForm}
                    ></ConfirmationPopUp>
                )}

                {PDIDialogBox && (
                    <ConfirmationPopUp
                        title={t('EVENT_DETAILS.PDI_INFORMATION_TITLE')}
                        body={<Typography>{t('EVENT_DETAILS.PDI_INFORMATION_ALERT')}</Typography>}
                        okButtonText={'OK'}
                        show={PDIDialogBox}
                        handleOk={closePDIQmaxDialogBox}
                        width="xs"
                        okButtonShow={true}
                    ></ConfirmationPopUp>
                )}

                {openQmaxDialogBox && (
                    <ConfirmationPopUp
                        title={t('EVENT_DETAILS.QMAX_INFORMATION_TITLE')}
                        body={<Typography>{t('EVENT_DETAILS.QMAX_INFORMATION_ALERT')}</Typography>}
                        okButtonText={'OK'}
                        show={openQmaxDialogBox}
                        handleOk={closeQmaxDialogBox}
                        width="xs"
                        okButtonShow={true}
                    ></ConfirmationPopUp>
                )}

                {infoBoxPhaseGraph && (
                    <ConfirmationPopUp
                        title={'Phase Resolved Charts'}
                        body={<Typography>{t('EVENT_DETAILS.PHASERESOLVEDGRAPH_ALERT')}</Typography>}
                        okButtonText={t('OK')}
                        show={infoBoxPhaseGraph}
                        handleOk={sendPRData}
                        width="xs"
                        okButtonShow={true}
                    ></ConfirmationPopUp>
                )}

                {isDataLoaded(alarmChannelData) && alarmChannelData.value.isPdiAlarm === 'true' && (
                    <Paper>
                        <PDIGraphDataProvider
                            deviceId={deviceId}
                            channelNumber={[parseInt(channelNumber)]}
                            startDate={alarmStartDate}
                            endDate={newAlarmEndDate}
                        >
                            <PDIGraph
                                monthValue={0}
                                pdiViewFullTrend={true}
                                popUpEvent={openPDIDialogBox}
                                alarmNotifyContent={
                                    <SuggestionAcceptReject
                                        resetConfirmation={openResetConfirmation}
                                        userAcceptConfirm={userAcceptConfirm}
                                        userEditForm={userEditForm}
                                        radioValue={radioValue}
                                        textValue={textValue}
                                        userRejectBox={userRejectConfirm}
                                        loggedUser={isLoggedUser}
                                        rejectUserId={isRejectedUserId}
                                        acceptUserId={isAcceptedUserId}
                                        IsSuggestionAccepted={accepted}
                                        IsSuggestionRejected={rejected}
                                        canEdit={isCanEdit}
                                        dataAnalyticsSuggestion={dataAnalyticsSuggestion}
                                        isAcceptedSuggestion={isAcceptedSuggestion}
                                        rejectedUserSuggestions={rejectedUserSuggestions}
                                    />
                                }
                            />
                            <Divider />
                            <ActionRow
                                label={t('INSULGARD.VIEWDETAIL')}
                                appRoute={redirectToSpecficTab('sensorTrend', channelNumber)}
                            ></ActionRow>
                        </PDIGraphDataProvider>
                    </Paper>
                )}

                {isDataLoaded(alarmChannelData) && alarmChannelData.value.isPdiAlarm !== 'true' && (
                    <Paper>
                        <MaxQmaxGraphProvider
                            deviceId={deviceId}
                            channelNumber={[parseInt(channelNumber)]}
                            startDate={alarmStartDate}
                            endDate={newAlarmEndDate}
                        >
                            <QmaxGraph
                                monthValue={0}
                                qMaxviewFullTrend={false}
                                popUpEvent={openQmaxDialogBoxContent}
                                alarmNotifyContent={
                                    <SuggestionAcceptReject
                                        resetConfirmation={openResetConfirmation}
                                        userAcceptConfirm={userAcceptConfirm}
                                        userEditForm={userEditForm}
                                        radioValue={radioValue}
                                        textValue={textValue}
                                        userRejectBox={userRejectConfirm}
                                        loggedUser={userId}
                                        rejectUserId={rejectUserId}
                                        acceptUserId={acceptUserId}
                                        IsSuggestionAccepted={accepted}
                                        IsSuggestionRejected={rejected}
                                        canEdit={canEdit}
                                        dataAnalyticsSuggestion={dataAnalyticsSuggestion}
                                        isAcceptedSuggestion={isAcceptedSuggestion}
                                        rejectedUserSuggestions={rejectedUserSuggestions}
                                    />
                                }
                            />
                            <Divider />
                            <ActionRow
                                label={t('INSULGARD.VIEWDETAIL')}
                                appRoute={redirectToSpecficTab('sensorTrend', channelNumber)}
                            ></ActionRow>
                        </MaxQmaxGraphProvider>
                    </Paper>
                )}

                {isDataLoaded(alarmChannelData) && alarmChannelData.value.channelNumber !== '' && (
                    <>
                        <Paper
                            className={classes.headerCont}
                            style={{ marginTop: '15px' }}
                            data-testid="alarm-phase-graph"
                        >
                            <ListSubheader
                                color="primary"
                                component="div"
                                style={{ fontWeight: 600, letterSpacing: 2 }}
                            >
                                {`${channelName} Phase Resolved Charts`}
                                <span style={{ float: 'right', color: 'gray' }}>
                                    {
                                        <Icon.Info
                                            onClick={prDialogPopup}
                                            style={{
                                                fontSize: '16px',
                                                position: 'relative',
                                                top: '3px',
                                                cursor: 'pointer',
                                            }}
                                        />
                                    }
                                </span>
                            </ListSubheader>
                            <DatetimeListDataProvider deviceId={deviceId}>
                                <PhaseResolvedGraphOverview
                                    deviceId={deviceId}
                                    isDisabled={true}
                                    alarnChannelNumber={parseInt(channelNumber)}
                                    alarmGraphDate={alarmEndDate}
                                    alarmDetail={true}
                                ></PhaseResolvedGraphOverview>

                                <ActionRow
                                    label={t('INSULGARD.VIEWPRDETAIL')}
                                    appRoute={redirectToSpecficTab('phaseResolved', findAlarmIndex)}
                                ></ActionRow>
                            </DatetimeListDataProvider>
                        </Paper>
                    </>
                )}
            </Paper>
        </div>
    );
};
